import { FC } from 'react';
import styled from 'styled-components';

import { ReactComponent as CommentIcon } from '@/assets/icons/comment.svg';
import Text from '@/components/Text';

const Box = styled.div`
  padding: 16px;
  border-radius: 8px;
  border: solid 1px ${({ theme }) => theme.colors.lightGray};
  margin: 24px;
  margin-bottom: 0;
`;

const Heading = styled(Text)`
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 12px;
  svg {
    color: ${({ theme }) => theme.colors.gray};
  }
`;

interface Props {
  comment: string;
}

const GeneralComment: FC<Props> = ({ comment }) => {
  return (
    <Box>
      <Heading $type="button">
        <CommentIcon />
        General Comment
      </Heading>
      <Text $type="smallHeadline">{comment}</Text>
    </Box>
  );
};

export default GeneralComment;
